(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@codejamboree/replace-tags"] = factory();
	else
		root["@codejamboree/replace-tags"] = factory();
})(this, () => {
return 